import { Checkbox } from "@rmwc/checkbox";
import { Radio } from "@rmwc/radio";
import { useDispatch, useSelector } from "react-redux";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import CurrencyFormat from "react-currency-format";
import Dropdown from "react-bootstrap/Dropdown";
import { extraItemsAction,   } from "../../../action/index.js";
import React from "react";

const DropDefaultToggle = React.forwardRef(({ children, onClick }, ref) => (
	<a
		href=""
		className="drop-default-toggle"
		ref={ref}
		onClick={(e) => {
			e.preventDefault();
			onClick(e);
		}}
	>
		{children}
	</a>
));

const Overhang = ({ isOldOverhang }) => {
	const const_var = useSelector((state) => state.reducer.const_var);
	const params = useSelector((state) => state.reducer.params);
	const dispatch = useDispatch();
	const a_p_d_a = const_var.a_p_d_a;
	let elementPrice = const_var.UpdatedPriceData?.elements ?? [];
	if (const_var.isLTBuilding) {
		a_p_d_a = JSON.parse(JSON.stringify(const_var.holdPricingResponse));
		elementPrice = const_var.lNTBuildingData.updatePriceDataElements.centerBuilding ?? [];
	}
	if (isOldOverhang == false && a_p_d_a?.overhang?.both) {
		a_p_d_a.overhang.both = { ...a_p_d_a.overhang.both, sheet_name: "1' Overhang", sheet_type: "both" };
	}
	let elemntPriceSideObj = "";
	let elemntPriceEndObj = "";
	const hasEndOverhang = !isOldOverhang && a_p_d_a.overhang?.end?.length > 0;
	const hasSideOverhang = !isOldOverhang && a_p_d_a.overhang?.side?.length > 0;
	let currentIndex = 0;
	let bothOverhangIndex = 0;
	let endOverhangIndex = 0;
	let sideOverhangIndex = 0;
	const hasBothOverhang = !isOldOverhang && a_p_d_a.overhang?.both;
	// Assign indexes sequentially
	if (hasBothOverhang) {
		bothOverhangIndex = currentIndex++;
	}

	if (hasEndOverhang) {
		endOverhangIndex = currentIndex++;
	}

	if (hasSideOverhang) {
		sideOverhangIndex = currentIndex++;
	}

	let ExtraItemsFeaturesArray = const_var.ExtraItemsFeaturesArray;
	if (const_var.isLTBuilding) {
		ExtraItemsFeaturesArray = const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding;
	}
	// both overhang
	const handleBothOverhang = (e) => {
		const nextVal = [];
		if (params.add_left_lean) {
			nextVal.push({ leanType: "left", d: const_var.leanGetDataLeft.overhang.both });
		}
		if (params.add_right_lean) {
			nextVal.push({ leanType: "right", d: const_var.leanGetDataRight.overhang.both });
		}
		if (params.add_front_lean) {
			nextVal.push({ leanType: "front", d: const_var.leanGetDataFront.overhang.both });
		}
		if (params.add_back_lean) {
			nextVal.push({ leanType: "back", d: const_var.leanGetDataBack.overhang.both });
		}
		dispatch(extraItemsAction(e.target.value, "overhangUpdate", a_p_d_a.overhang.both, bothOverhangIndex, "overhang", undefined, nextVal.length ? { forDummy: true, nextVal } : undefined));
	};
	/************** end overhang *******************/
	const handleEndOverhang = (e) => {
		const nextVal = [];
		if (params.add_left_lean) {
			nextVal.push({ leanType: "left", d: const_var.leanGetDataLeft.overhang.end[0] });
		}
		if (params.add_right_lean) {
			nextVal.push({ leanType: "right", d: const_var.leanGetDataRight.overhang.end[0] });
		}
		if (params.add_front_lean) {
			nextVal.push({ leanType: "front", d: const_var.leanGetDataFront.overhang.end[0] });
		}
		if (params.add_back_lean) {
			nextVal.push({ leanType: "back", d: const_var.leanGetDataBack.overhang.end[0] });
		}
		dispatch(extraItemsAction(e.target.value, "overhangUpdate", a_p_d_a.overhang.end[0], endOverhangIndex, "overhang", undefined, nextVal.length ? { forDummy: true, nextVal } : undefined));
	};

	/************** side overhang *******************/

	const handleSideOverhang = (e) => {
		const nextVal = [];
		if (params.add_left_lean) {
			nextVal.push({ leanType: "left", d: const_var.leanGetDataLeft.overhang.side[0] });
		}
		if (params.add_right_lean) {
			nextVal.push({ leanType: "right", d: const_var.leanGetDataRight.overhang.side[0] });
		}
		if (params.add_front_lean) {
			nextVal.push({ leanType: "front", d: const_var.leanGetDataFront.overhang.side[0] });
		}
		if (params.add_back_lean) {
			nextVal.push({ leanType: "back", d: const_var.leanGetDataBack.overhang.side[0] });
		}
		dispatch(extraItemsAction(e.target.value, "overhangUpdate", a_p_d_a.overhang.side[0], sideOverhangIndex, "overhang", undefined, nextVal.length ? { forDummy: true, nextVal } : undefined));
	};

	return (
		<>
			{a_p_d_a?.overhang?.end?.length>0 && (

				<div className="control-field-bar">
					<div className="control-field">
						<div className="check-group">
							<Checkbox
								checked={const_var.isOverhang?.end?.isChecked}
								label={a_p_d_a.overhang.end[0].sheet_name}
								onChange={(e) => handleEndOverhang(e)}
							// disabled={a_p_d_a.overhang.end[0].is_included == 1 ? true : false}
							/>
						</div>
					</div>
					{const_var.isOverhang?.end?.isChecked ? (
						<div className="control-field-action">
							{const_var.loginSession == true ? (
								<div className={"price-box" + (a_p_d_a.overhang.end[0].is_included == 1 ? " xdisabled" : "")}>
									<EditPriceItem
										updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]}
										jsonObj={"extraitems"}
										jsonObjValue={true}
										jsonObjKey={const_var.isOverhang?.end?.selected}
										elementObjIndex={endOverhangIndex}
										extraItemType={"extraitemsCheckbox"}
									/>
								</div>
							) : (
								<div className={"price-box-type-2" + (a_p_d_a.overhang.end[0].is_included == 1 ? " xdisabled" : "")}>
									{const_var.hide_price_calculation != 1 && !const_var.loginSession && elementPrice[a_p_d_a.overhang.end[0].sheet_name]?.item_price >= 0 && (
										<CurrencyFormat value={elementPrice[a_p_d_a.overhang.end[0].sheet_name]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
									)}
								</div>
							)}
						</div>
					) : null}
				</div>
			)}

			{a_p_d_a.overhang?.side?.length>0 && (
				<>
					<div className="control-field-bar">
						<div className="control-field">
							<div className="check-group">
								<Checkbox
									checked={const_var.isOverhang?.side?.isChecked}
									label={a_p_d_a.overhang.side[0].sheet_name}
									onChange={(e) => handleSideOverhang(e)}
								// disabled={a_p_d_a.overhang.side[0].is_included == 1 ? true : false}
								/>
							</div>
						</div>
						{const_var.isOverhang?.side?.isChecked ? (
							<div className="control-field-action">
								{const_var.post_data.building != undefined && const_var.loginSession ? (
									<div className={"price-box" + (a_p_d_a.overhang.side[0].is_included == 1 ? " xdisabled" : "")}>
										<EditPriceItem
											updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]}
											jsonObj={"extraitems"}
											jsonObjValue={true}
											jsonObjKey={const_var?.isOverhang?.side?.selected}
											elementObjIndex={sideOverhangIndex}
											extraItemType={"extraitemsCheckbox"}
											isOverhangType={"side"}
										/>
									</div>
								) : (
									<div className={"price-box-type-2" + (a_p_d_a.overhang.side[0].is_included == 1 ? " xdisabled" : "")}>
										{const_var.hide_price_calculation != 1 && !const_var.loginSession && elementPrice?.[a_p_d_a.overhang.side[0].sheet_name]?.item_price >= 0 && (
											<CurrencyFormat value={elementPrice[a_p_d_a.overhang.side[0].sheet_name]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
										)}
									</div>
								)}
							</div>
						) : null}
					</div>
				</>
			)}

			{a_p_d_a.overhang?.both?.length && (
				<>
					<div className="control-field-bar">
						<div className="control-field">
							<div className="check-group">
								<Checkbox
									checked={const_var.isOverhang?.both?.isChecked}
									label={a_p_d_a.overhang.both.sheet_name}
									onChange={(e) => handleBothOverhang(e)}
								// disabled={const_var.a_p_d_a?.overhang.both?.is_included ? true : false}
								/>
							</div>
						</div>
						{const_var.isOverhang?.both?.isChecked ? (
							<div className="control-field-action">
								{const_var.loginSession == true ? (
									<div className={"price-box" + (const_var.a_p_d_a?.overhang.both?.is_included ? " xdisabled" : "")}>
										<EditPriceItem
											updatedPriceDataObj={const_var.lNTBuildingData["updatePriceDataElements"]["centerBuilding"]}
											jsonObj={"extraitems"}
											jsonObjValue={true}
											jsonObjKey={const_var?.isOverhang?.both?.selected}
											elementObjIndex={bothOverhangIndex}
											extraItemType={"extraitemsCheckbox"}
										/>
									</div>
								) : (
									<div className={"price-box-type-2" + (const_var.a_p_d_a?.overhang.both?.is_included ? " xdisabled" : "")}>
										{const_var.hide_price_calculation != 1 && const_var.loginSession == false && elementPrice?.[a_p_d_a.overhang.both.sheet_name]?.item_price >= 0 && (
											<CurrencyFormat value={elementPrice[a_p_d_a.overhang.both.sheet_name]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
										)}
									</div>
								)}
							</div>
						) : null}
					</div>
				</>
			)}
		</>
	);
};

export default Overhang;
